<template>
  <div>
    <div
      class="cname"
      v-for="(str, index) in splitStr(item.yards)"
      :key="index"
      >{{ str }}</div
    >
  </div>
</template>

<script>
export default {
  name: "order-status-yards",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
